const filter = (value): string => {
  if (!value) {
    return ''
  }

  return value
    .replace(/^\+55/, '')
    .replace(/^(\+\d{2})?(\d{2})(.+)(\d{4})$/, '$1 ($2) $3-$4')
}

export default filter
